import { render, staticRenderFns } from "./match-sign-result.vue?vue&type=template&id=7bd96c24&scoped=true"
import script from "./match-sign-result.vue?vue&type=script&lang=js"
export * from "./match-sign-result.vue?vue&type=script&lang=js"
import style0 from "./match-sign-result.vue?vue&type=style&index=0&id=7bd96c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd96c24",
  null
  
)

export default component.exports